export enum NotificationObject {
  BIN = 'BIN',
  TYRE = 'TYRE'
}

